// App version - update this when deploying significant changes
export const APP_VERSION = '1.0.2';

const VERSION_KEY = 'bilbase_app_version';
const LAST_CHECK_KEY = 'bilbase_last_version_check';

export function getStoredVersion(): string | null {
  return localStorage.getItem(VERSION_KEY);
}

export function needsRefresh(): boolean {
  const storedVersion = getStoredVersion();
  return storedVersion !== null && storedVersion !== APP_VERSION;
}

export function checkAndUpdateVersion(): boolean {
  const storedVersion = localStorage.getItem(VERSION_KEY);
  
  if (storedVersion !== APP_VERSION) {
    // Clear old caches
    clearAppCaches();
    
    // Store new version
    localStorage.setItem(VERSION_KEY, APP_VERSION);
    localStorage.setItem(LAST_CHECK_KEY, Date.now().toString());
    
    return true; // Version was updated
  }
  
  return false; // No update needed
}

async function clearAppCaches(): Promise<void> {
  // Clear React Query cache from localStorage if it exists
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.startsWith('tanstack') || key.startsWith('REACT_QUERY'))) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
  
  // Clear service worker caches if available
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
    } catch (e) {
      console.log('Cache clearing not available:', e);
    }
  }
  
  console.log(`[Version] Updated to ${APP_VERSION}, caches cleared`);
}

// Force a clean reload of the page
export function forceRefresh(): void {
  // Clear all caches first
  clearAppCaches().then(() => {
    // Use location.reload with cache bypass
    window.location.reload();
  });
}
